module.exports = __webpack_public_path__ + "static/logo-2cdab0b728ca8fa244d321493670284c.svg";